import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'request-list-filter',
  templateUrl: './request-list-filter.component.html',
  styleUrls: ['./request-list-filter.component.css']
})
export class RequestListFilterComponent implements OnInit {
  IsHidden: boolean = false;
  filterForm: FormGroup;
  @Output() onFilter = new EventEmitter<any>();
  constructor(private formBulder: FormBuilder) {

  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    const today = new Date();
    this.filterForm = this.formBulder.group({
      reference: '',
      hospitalNum: '',
      labNumber: '',
      surname: [''],
      forename: [''],
      email: '',
      dob:'',
      fromDate: '',
      toDate: ''
    });

    this.filterForm.setValue({
      reference: '',
      hospitalNum: '',
      labNumber: '',
      surname: [''],
      forename: [''],
      dob: '',
      email: '',
      toDate: today.toISOString().substring(0, 10),
      fromDate: (today.addDays(-14)).toISOString().substring(0, 10)
    });
  }

  filterTestRequests(filterData) {
    this.onFilter.emit(filterData);
  }
}
